(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contactforum"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var inputs = document.querySelectorAll('.dior-input input, .dior-input textarea');
    var messageField = document.getElementById('message');
    var charCount = document.getElementById('char-count');

    // Handle floating labels with animation
    inputs.forEach(function(input) {
      // Add placeholder attribute to make the :not(:placeholder-shown) selector work
      input.setAttribute('placeholder', ' ');

      // Check initial state
      if (input.value) {
        input.classList.add('has-value');
      }

      // Add event listeners
      input.addEventListener('focus', function() {
        this.parentElement.classList.add('focused');
      });

      input.addEventListener('blur', function() {
        this.parentElement.classList.remove('focused');
        this.classList.toggle('has-value', this.value.length > 0);
      });

      input.addEventListener('input', function() {
        this.classList.toggle('has-value', this.value.length > 0);
      });
    });

    // Character counter
    if (messageField && charCount) {
      var maxLength = parseInt(charCount.textContent) || 360;

      messageField.addEventListener('input', function() {
        var remaining = maxLength - this.value.length;
        charCount.textContent = remaining;
        charCount.style.color = remaining < 50 ? '#ff0000' : '#666';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
